import React from "react";
import StatusApplication from "./StatusApplication";
import { checkPermission, permissionsConfig } from '../AdminPermission/PermissionChecker';

const PendingApplication = () => {

  const editApplicationPermission = checkPermission(
    permissionsConfig.editPendingApplications.role,
    permissionsConfig.editPendingApplications.action,
    permissionsConfig.editPendingApplications.type
  );
    
  const deleteApplicationPermission = checkPermission(
    permissionsConfig.deletePendingApplications.role,
    permissionsConfig.deletePendingApplications.action,
    permissionsConfig.deletePendingApplications.type
  );

  return (
    <StatusApplication appStatus="2" title="Document Pending" subTitle="Document Pending" application_type="0" pageFrom="pending-applications" editApplicationPermission={editApplicationPermission} deleteApplicationPermission={deleteApplicationPermission}></StatusApplication>
  )
};

export default PendingApplication;
